import { translate } from 'utils/translate';

export const getDayLabel = (daysQuantity: number) => {
   const pluralRules = new Intl.PluralRules('pl-PL');
   const grammaticalNumber = pluralRules.select(daysQuantity);
   return grammaticalNumber === 'one' ? translate('labels.day_one') : translate('labels.day_many');
};
